<template>
  <section class="auth-form-container">
    <div class="auth-form-name">Sign in</div>
    <LoginForm :onSubmit="login" />
  </section>
</template>

<script>
import LoginForm from '@/components/shared/LoginForm';

export default {
  name: 'Login',
  components: { LoginForm },
  methods: {
    async login(data) {
      const res = await this.$http.post('login', data);
      this.$store.commit('auth/login', res.data.access_token);
      this.$router.push('/');
    },
  },
};
</script>
